import { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "./PharmacistRxDashboard.css";

export default function PharmacistRxDashboard() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showRejectId, setShowRejectId] = useState(null);
  const [note, setNote] = useState("");
 const [user, setUser] = useState(null);

  const navigate = useNavigate();

  const loadRequests = async () => {
    try {
      const res = await axios.get("/pharmacist/availability-requests/");
      setRequests(res.data.requests || []);
    } catch (err) {
      console.error("Fetch failed ❌", err);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };
const loadUser = async () => {
  const res = await axios.get("/user-info/");
  setUser(res.data);
};

useEffect(() => {
  loadUser();
  loadRequests();
}, []);

const approveRequest = async (id) => {
  try {
    await axios.post(`/availability/requests/${id}/action/`, {
      action: "approve",
      id: id
    });

    loadRequests(); // refresh immediately
  } catch (e) {
    console.error(e);

    // 🔥 always refresh (UI sync fix)
    loadRequests();

    alert("Request processed, refreshing...");
  }
};

const submitReject = async (id) => {
  if (!note.trim()) {
    alert("Enter reason");
    return;
  }


  try {
    await axios.post(`/availability/requests/${id}/action/`, {
      action: "reject",
      note: note,
    });

    console.log("Reject success");

    setShowRejectId(null);
    setNote("");
    loadRequests();
  } catch (err) {
    console.error("Reject failed:", err);
    alert("Reject failed");
  }
};




if (loading) {
  return <p className="center">Loading...</p>;
}




  return (
    <div className="rx-container">
      <div className="rx-header">
        <h2>Pharmacist Dashboard</h2>

  <div className="rx-header-left">
    <div className="rx-avatar">
      {user?.name?.charAt(0) || "P"}
    </div>

    <div className="rx-profile">
      <strong>{user?.name || "Pharmacist"}</strong>
      <span>{user?.phone || "—"}</span>
    </div>
  </div>
        <button className="refresh-btn" onClick={loadRequests}>
          🔄 Refresh
        </button>
      </div>

      

      {!loading && requests.length === 0 && (
        <p className="center">No availability requests</p>
      )}

      {requests.map((rx, index) => {




console.log("Handled:", rx.handled_by_id, "User:", user?.id);



        const isPending = rx.status === "pending";
        const isApproved = rx.status === "approved";
        const isPriced = rx.status === "priced";
	const isMyApproval =
  rx.handled_by_id && user && rx.handled_by_id === user.id;
        return (
          <div key={rx.id} className={`rx-card ${index === 0 ? "new" : ""}`}>
            {index === 0 && <div className="badge-new">NEW</div>}

            <div className="rx-row"><span>ID</span><b>#{rx.id}</b></div>
            <div className="rx-row"><span>Customer</span><b>{rx.customer_name}</b></div>
            <div className="rx-row"><span>Phone</span><b>{rx.profile_phone}</b></div>
            <div className="rx-row"><span>Callback</span><b>{rx.callback_phone}</b></div>
            <div className="rx-row"><span>Hospital</span><b>{rx.hospital_name || "Outside"}</b></div>

            <div className={`rx-status ${rx.status}`}>{rx.status}</div>

{Array.isArray(rx.files) && rx.files.length > 0 ? (
  <div style={{ marginTop: 10 }}>
    <b>📄 Prescriptions:</b>

    {rx.files.map((file, i) => (
      <div key={i} style={{ marginTop: 6 }}>

        {file.toLowerCase().endsWith(".pdf") ? (
          <>
            <a
              href={file}
              target="_blank"
              rel="noopener noreferrer"
              className="rx-link"
            >
              📄 Open PDF
            </a>
            <br />
            <a href={file} download>⬇ Download</a>
          </>
        ) : (
          <>
            <img
              src={file}
              alt="rx"
              onClick={() => window.open(file, "_blank")}
              style={{
                width: "100%",
                maxWidth: 220,
                borderRadius: 8,
                border: "1px solid #ddd",
                cursor: "pointer"
              }}
            />
            <br />
            <a href={file} download>⬇ Download</a>
          </>
        )}

      </div>
    ))}
  </div>
) : (
  <p style={{ color: "gray" }}>No prescription uploaded</p>
)}
<p style={{
  background: "#fff3cd",
  padding: 8,
  borderRadius: 6,
  fontSize: 13,
  marginTop: 10
}}>
  📌 Tip: Download prescriptions to avoid loading issues.
</p>
            {isPending && (
              <div className="rx-actions">
                <button className="approve" onClick={() => approveRequest(rx.id)}>
                  Approve
                </button>
                <button className="reject" onClick={() => setShowRejectId(rx.id)}>
                  Reject
                </button>
              </div>
            )}



{isApproved && isMyApproval && !isPriced && (
  <button
    className="pricing-btn"
    onClick={() => navigate(`/pharmacist/pricing/${rx.id}`)}
  >
    Proceed to Pricing →
  </button>
)}


            {isPriced && (
              <p className="locked">🔒 Pricing already sent</p>
            )}

            {showRejectId === rx.id && isPending && (
              <div className="reject-box">
                <textarea
                  placeholder="Rejection reason"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
                <button onClick={() => submitReject(rx.id)}>
                  Submit Rejection
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
